import { groupBy } from "lodash";

import {
	FORM_CAMPAIGNS, 
	ACCOUNT_CAMPAIGN_INTERACTIONS 
} from "../routes";

function CampaignService(
	api,
	$logger
) {
	const service = this;
	let forceRefreshOnNextLoad = false;
	service.versionIdToCampaignMap = {};
	const callbacks = [];

	service.addOnCampaignsChanged = (callback) => {
		callbacks.push(callback);
		if(service.campaigns !== undefined) {
			callback(service.campaigns);
		}
	};

	service.loadCurrentCampaigns = async(formId, reload = false) => {
		if(!reload && !forceRefreshOnNextLoad && service.campaigns !== undefined) {
			return Promise.resolve(service.campaigns);
		}

		forceRefreshOnNextLoad = false;

		const campaignsPromise = api.get(FORM_CAMPAIGNS(formId));
		const interactionsPromise = api.get(ACCOUNT_CAMPAIGN_INTERACTIONS());

		const [campaigns, interactions] = await Promise.all([campaignsPromise, interactionsPromise]);

		service.subjectInteractionsByVersionId = groupBy(interactions, i => i.VersionId);

		service.campaigns = campaigns ?? [];
		service.versionIdToCampaignMap = campaigns.reduce((map, campaign) => {
			campaign.Versions.forEach(version => {
				map[version.Id] = campaign.Id;
			});

			return map;
		}, {});

		for(const callback of callbacks) {
			callback(service.campaigns);
		}

		return service.campaigns;
	};

	service.invalidateCampaigns = () => {
		forceRefreshOnNextLoad = true;
		service.campaigns = [];
		service.versionIdToCampaignMap = {};
		service.subjectInteractionsByVersionId = {};
	};

	service.getCurrentLatestVersionForCampaign = (campaign) => {
		const now = new Date();
		const allCurrentVersions = campaign.Versions.filter(v => {
			const begin = v.BeginInclusive !== undefined ? new Date(v.BeginInclusive) : undefined;
			const end = v.EndExclusive !== undefined ? new Date(v.EndExclusive) : undefined;

			return (begin === undefined || begin <= now) && (end === undefined || end > now);
		});

		const reverseSortedVersions = [...allCurrentVersions].sort((a, b) => b.Version.localeCompare(a.Version));
		return reverseSortedVersions[0];
	};

	return service;
}

export default angular
	.module("vesl.services.campaign-service", [])
	.service("campaignService", CampaignService).name;